
(function() {
  var result = { translations: { "es": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Alban\xE9s", "sq-al": "Alban\xE9s - Albania", "ar": "\xC1rabe", "ar-dz": "\xC1rabe - Argelia", "ar-bh": "\xC1rabe - Bahr\xE9in", "ar-eg": "\xC1rabe - Egipto", "ar-iq": "\xC1rabe - Irak", "ar-jo": "\xC1rabe - Jordania", "ar-kw": "\xC1rabe - Kuwait", "ar-lb": "\xC1rabe - L\xEDbano", "ar-ly": "\xC1rabe - Libia", "ar-ma": "\xC1rabe - Marruecos", "ar-om": "\xC1rabe - Om\xE1n", "ar-qa": "\xC1rabe - Qatar", "ar-sa": "\xC1rabe - Arabia Saudita", "ar-sd": "\xC1rabe - Sud\xE1n", "ar-sy": "\xC1rabe - Siria", "ar-tn": "\xC1rabe - T\xFAnez", "ar-ae": "\xC1rabe - Emiratos \xC1rabes Unidos", "ar-ye": "\xC1rabe - Yemen", "as": "Asam\xE9s", "az": "Azerbaiyano", "hy": "Armenio", "eu": "Vasco", "be": "Bielorruso", "be-by": "Bielorruso - Bielorrusia", "bn": "Bengal\xED", "bg": "B\xFAlgaro", "bg-bg": "B\xFAlgaro - Bulgaria", "bs": "Bosnio", "ca": "Catal\xE1n", "ca-es": "Catal\xE1n - Catal\xE1n", "zh": "Chino", "zh-cn": "Chino - simplificado", "zh-hk": "Chino - Hong Kong", "zh-mo": "Chino - Macao", "zh-sg": "Chino - Singapur", "zh-tw": "Chino - tradicional", "zh-chs": "Chino (simplificado)", "zh-cht": "Chino (tradicional)", "zh-hans": "Chino (Han simplificado)", "zh-hant": "Chino (Han tradicional)", "hr": "Croata", "hr-hr": "Croata - Croacia", "cs": "Checo", "cs-cz": "Checo - Rep\xFAblica Checa", "da": "Dan\xE9s", "da-dk": "Dan\xE9s - Dinamarca", "nl": "Holand\xE9s", "nl-be": "Holand\xE9s - B\xE9lgica", "nl-ch": "Holand\xE9s - Suiza", "nl-lu": "Holand\xE9s - Luxemburgo", "nl-nl": "Holand\xE9s - Pa\xEDses Bajos", "en": "Ingl\xE9s", "en-ae": "Ingl\xE9s - Emiratos \xC1rabes Unidos", "en-au": "Ingl\xE9s - Australia", "en-be": "Ingl\xE9s - B\xE9lgica", "en-ca": "Ingl\xE9s - Canad\xE1", "en-ch": "Ingl\xE9s - Suiza", "en-cn": "Ingl\xE9s - China", "en-de": "Ingl\xE9s - Alemania", "en-ee": "Ingl\xE9s - Estonia", "en-es": "Ingl\xE9s - Espa\xF1a", "en-fr": "Ingl\xE9s - Francia", "en-hk": "Ingl\xE9s - Hong Kong", "en-in": "Ingl\xE9s - India", "en-ie": "Ingl\xE9s - Irlanda", "en-ke": "Ingl\xE9s - Kenia", "en-lu": "Ingl\xE9s - Luxemburgo", "en-my": "Ingl\xE9s - Malasia", "en-mt": "Ingl\xE9s - Malta", "en-mx": "Ingl\xE9s - M\xE9xico", "en-nl": "Ingl\xE9s - Pa\xEDses Bajos", "en-nz": "Ingl\xE9s - Nueva Zelanda", "en-ph": "Ingl\xE9s - Filipinas", "en-pk": "Ingl\xE9s - Pakist\xE1n", "en-se": "Ingl\xE9s - Suecia", "en-sg": "Ingl\xE9s - Singapur", "en-tn": "Ingl\xE9s - T\xFAnez", "en-za": "Ingl\xE9s - Sud\xE1frica", "en-gb": "Ingl\xE9s - Reino Unido", "en-us": "Ingl\xE9s - Estados Unidos", "en-zw": "Ingl\xE9s - Zimbabwe", "et": "Estonio", "et-ee": "Estonio - Estonia", "fo": "Fero\xE9s", "fa": "Farsi", "fi": "Finland\xE9s", "fi-fi": "Finland\xE9s - Finlandia", "fil": "Filipino", "fr": "Franc\xE9s", "fr-be": "Franc\xE9s - B\xE9lgica", "fr-ca": "Franc\xE9s - Canad\xE1", "fr-fr": "Franc\xE9s - Francia", "fr-lu": "Franc\xE9s - Luxemburgo", "fr-mc": "Franc\xE9s - M\xF3naco", "fr-ch": "Franc\xE9s - Suiza", "fr-tn": "Franc\xE9s - T\xFAnez", "gl": "Gallego", "ka": "Georgiano", "de": "Alem\xE1n", "de-at": "Alem\xE1n - Austria", "de-de": "Alem\xE1n - Alemania", "de-gr": "Alem\xE1n - Alemania", "de-li": "Alem\xE1n - Liechtenstein", "de-lu": "Alem\xE1n - Luxemburgo", "de-ch": "Alem\xE1n - Suiza", "el": "Griego", "el-cy": "Griego - Chipre", "el-gr": "Griego - Grecia", "gu": "Guyarat\xED", "haw": "Hawaiano", "ha": "Hausa", "he": "Hebreo", "he-il": "Hebreo - Israel", "iw-il": "Hebreo - Israel", "hi": "Hindi", "hi-in": "Hindi - India", "hu": "H\xFAngaro", "hu-hu": "H\xFAngaro - Hungr\xEDa", "is": "Island\xE9s", "is-is": "Island\xE9s - Islandia", "id": "Indonesio", "in-id": "Indonesio - Indonesia", "ga": "Irland\xE9s", "ga-ie": "Irland\xE9s - Irlanda", "it": "Italiano", "it-it": "Italiano - Italia", "it-ch": "Italiano - Suiza", "ja": "Japon\xE9s", "ja-jp": "Japon\xE9s - Jap\xF3n", "kn": "Canar\xE9s", "kk": "Kasajo", "kok": "Konkani", "ko": "Coreano", "ko-kr": "Coreano - Corea del Sur", "ku": "Kurdo", "ky": "Kirgu\xEDs", "ky-kg": "Kirgu\xEDs", "lo": "Idioma Laosiano", "lv": "Let\xF3n", "lv-lv": "Let\xF3n - Letonia", "lt": "Lituano", "lt-lt": "Lituano - Lituania", "mk": "Macedonio", "mk-mk": "Macedonio - Macedonia", "ml": "Malayalam", "ms": "Malayo", "ms-bn": "Malayo - Brunei", "ms-my": "Malayo - Malasia", "mt": "Malt\xE9s", "mt-mt": "Malt\xE9s - Malta", "mr": "Marat\xED", "mn": "Mongol", "my": "Birmano", "my-mm": "Birmano - Myanmar (Birmania)", "ne": "Nepal\xED", "no": "Noruego", "nb": "Bokmal noruego", "nb-no": "Bokmal noruego - Noruega", "no-no": "Noruego - Noruega", "pl": "Polaco", "pl-pl": "Polaco - Polonia", "pt": "Portugu\xE9s", "pt-br": "Portugu\xE9s - Brasil", "pt-pt": "Portugu\xE9s - Portugal", "pa": "Panyab\xED", "pa-in": "Punjab\xED - India", "pa-pk": "Punjab\xED - Pakist\xE1n", "ro": "Rumano", "ro-ro": "Rumano - Rumania", "ru": "Ruso", "ru-ru": "Ruso - Rusia", "rw-rw": "Kinyarwanda", "sa": "S\xE1nscrito", "si": "Cingal\xE9s", "sr": "Serbio", "sr-ba": "Serbio - Bosnia y Herzegovina", "sr-me": "Serbio - Montenegro", "sr-rs": "Serbio - Serbia", "sr-cs": "Serbio - Serbia y Montenegro (antigua)", "sk": "Eslovaco", "sk-sk": "Eslovaco - Eslovaquia", "sl": "Esloveno", "sl-si": "Esloveno - Eslovenia", "es": "Espa\xF1ol", "es-ar": "Espa\xF1ol - Argentina", "es-bo": "Espa\xF1ol - Bolivia", "es-cl": "Espa\xF1ol - Chile", "es-co": "Espa\xF1ol - Colombia", "es-cr": "Espa\xF1ol - Costa Rica", "es-cu": "Espa\xF1ol - Cuba", "es-do": "Espa\xF1ol - Rep\xFAblica Dominicana", "es-ec": "Espa\xF1ol - Ecuador", "es-sv": "Espa\xF1ol - El Salvador", "es-gt": "Espa\xF1ol - Guatemala", "es-hn": "Espa\xF1ol - Honduras", "es-mx": "Espa\xF1ol - M\xE9xico", "es-ni": "Espa\xF1ol - Nicaragua", "es-pa": "Espa\xF1ol - Panam\xE1", "es-py": "Espa\xF1ol - Paraguay", "es-pe": "Espa\xF1ol - Per\xFA", "es-pr": "Espa\xF1ol - Puerto Rico", "es-es": "Espa\xF1ol - Espa\xF1a", "es-us": "Espa\xF1ol - Estados Unidos", "es-uy": "Espa\xF1ol - Uruguay", "es-ve": "Espa\xF1ol - Venezuela", "sw": "Swahili", "sv": "Sueco", "sv-fi": "Sueco - Finlandia", "sv-se": "Sueco - Suecia", "sy": "Sir\xEDaco", "ta": "Tamil", "tt": "T\xE1rtaro", "te": "Telugu", "th": "Tailand\xE9s", "th-th": "Tailand\xE9s - Tailandia", "tl": "Tagalo", "tr": "Turco", "tr-tr": "Turco - Turqu\xEDa", "uk": "Ucranio", "uk-ua": "Ucrania - Ucrania", "ur": "Urdu", "uz": "Uzbeco", "vi": "Vietnamita", "vi-vn": "Vietnamita - Vietnam", "yi": "Y\xEDdish", "zu": "Zul\xFA" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "es": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} m", "hours": "{{ hours }} h", "days": "{{ days }} d", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "es": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "es": { "videoPlayer": { "htmlTitle": "V\xEDdeo de HubSpot", "htmlTitleWithVideo": "{{ videoTitle }} | V\xEDdeo de HubSpot", "controls": { "audioPlayer": "Reproductor de audio", "videoPlayer": "Reproductor de v\xEDdeo", "play": "Reproducir", "playVideo": "Reproducir v\xEDdeo", "pause": "Pausar", "replay": "Repetici\xF3n", "currentTime": "Hora actual", "duration": "Duraci\xF3n", "remainingTime": "Tiempo restante", "fullscreen": "Pantalla completa", "exitFullscreen": "Salir de pantalla completa", "mute": "Silenciar", "unmute": "Activar audio", "volumeLevel": "Nivel de volumen", "captions": "Leyendas", "captionsOff": "Desactivado", "seekBar": "Ajustar posici\xF3n", "chapter": "Cap\xEDtulo", "elapsedTime": "Elapsed time: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Opciones de reproducci\xF3n", "playbackRate": "Velocidad de reproducci\xF3n:", "quality": "Calidad:", "normal": "Normal", "auto": "(Autom\xE1tica)" }, "formModal": { "defaultThankYouMessage": "\xA1Muchas gracias por la respuesta!", "inlineMessageButton": "Ver video" }, "ctaModal": { "imgAlt": "CTA de v\xEDdeo" }, "errors": { "generic": { "heading": "No se ha podido cargar el v\xEDdeo" }, "UNAUTHORIZED": { "heading": "V\xEDdeo no habilitado" }, "VIDEO_NOT_FOUND": { "heading": "Video no encontrado" }, "INVALID_URL": { "heading": "Video no encontrado" }, "UNSUPPORTED_EMBED": { "heading": "V\xEDdeo no disponible", "extra": "Este v\xEDdeo no se puede visualizar de forma externa." }, "refreshLink": "Int\xE9ntelo de nuevo" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "es": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:es', {version: 'static-1.29208'}); }
})();


